// API
import { fetchStudentDetails, addNotesToStudent } from "@/api";

// Deserializer
import { deserializeStudentNotes } from "@/utils/deserializers/studentDetailsDeserializer";

// Actions
import { showToasterMessage } from "./commonActions";

// Constants
export const INITIALIZE_STUDENT_NOTES = "INITIALIZE_STUDENT_NOTES";
export const LOADING_STUDENT_NOTES = "LOADING_STUDENT_NOTES";
export const RESET_STUDENT_NOTES = "RESET_STUDENT_NOTES";

export const initializeStudentNotes = (payload) => {
    return { type: INITIALIZE_STUDENT_NOTES, payload };
};

export const loadingStudentNotes = (payload) => {
    return { type: LOADING_STUDENT_NOTES, payload };
};

export const uploadStudentNote = (registrantCode, payload, successCb) => {
    return (dispatch) => {
        dispatch(loadingStudentNotes(true));
        addNotesToStudent(registrantCode, payload)
            .then(() => {
                dispatch(studentNotesGetAndStore(registrantCode, payload));
                dispatch(showToasterMessage("Note Added successfully", "success"));
                successCb && successCb();
            })
            .catch((err) => {
                dispatch(showToasterMessage("Unable To Add Note", "error"));
                dispatch(loadingStudentNotes(false));
                console.log(err);
            });
    };
};

export const studentNotesGetAndStore = (registrantCode, payload) => {
    return (dispatch) => {
        dispatch({ type: RESET_STUDENT_NOTES });
        fetchStudentDetails({ ...payload, registrant_code: registrantCode })
            .then((res) => {
                const studentDetails = res.data.student_details || [];
                const student = studentDetails.find((item) => item.registrant_code === registrantCode)
                    || studentDetails[0]
                    || {};
                dispatch(initializeStudentNotes(deserializeStudentNotes(student.all_notes)));
            })
            .catch((err) => {
                console.log(err);
                dispatch(initializeStudentNotes([]));
            });
    };
};
